import React, { Component } from 'react';
// import './ActionItem.pcss'
interface Props {
  actionLabel: string;
  actionValue: string;
  actionType?: string;
  handleSubmit;
  listElemClass?;
}

interface State {
  null;
}

let suggestionsList = ['SUGGESTION_TYPE_1', 'SUGGESTION_TYPE_2'];

class ActionItem extends Component<Props, State> {
  render() {
    return (
      //add custom type for this to track external links (Lead Gen)
      typeof this.props.actionType != 'undefined' ? (
        this.props.actionType.toLowerCase() == 'typeint' ? (
          <div
            className="action-elem"
            onClick={this.props.handleSubmit.bind(this, this.props.actionValue)}
          >
            {this.props.actionLabel}
          </div>
        ) : this.props.actionType.toLowerCase() == 'quicklink' ||
          this.props.actionType.toLowerCase() == 'disamb' ||
          suggestionsList.indexOf(this.props.actionType) > -1 ? (
          <div
            className="action-elem disamb"
            onClick={this.props.handleSubmit.bind(this, this.props.actionValue)}
          >
            {this.props.actionLabel}
          </div>
        ) : (
          // eslint-disable-next-line react/jsx-no-target-blank
          <a
            className="action-elem-ext"
            target="_blank"
            href={this.props.actionValue}
          >
            {this.props.actionLabel}
          </a>
        )
      ) : (
        <div
          className={`action-elem ${this.props.listElemClass || ''}`}
          onClick={this.props.handleSubmit.bind(this, this.props.actionValue)}
        >
          {this.props.actionLabel}
        </div>
      )
    );
  }
}

export default ActionItem;
